import { getCurrentEnv } from 'app/helpers/getCurrentEnv';
import { isLoggedInAsAdmin } from 'app/helpers/isLoggedInAsAdmin';
import { AppState } from 'app/store';
import { SplashScreen } from 'app/ui/components/SplashScreen';
import rg4js from 'raygun4js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';

import { isRaygunEnabled } from '../errors/errors.lib';
import useLoggedStatus from '../hooks/useLoggedStatus';

interface HasToBeLoggedInGuardProps {
  children: React.ReactNode;
}

export const HasToBeLoggedInGuard = (props: HasToBeLoggedInGuardProps) => {
  const { children } = props;
  const { pathname } = useLocation();
  const user = useSelector(({ auth }: AppState) => auth.user);
  const waitAuthCheck = useLoggedStatus(user);

  if (waitAuthCheck) {
    return <SplashScreen />;
  }

  if (!user) {
    return (
      <Redirect
        to={{
          pathname: '/auth/logged-out',
          state: { referrer: pathname },
        }}
      ></Redirect>
    );
  }

  if (
    user.id === '282' &&
    getCurrentEnv() === 'production' &&
    !isLoggedInAsAdmin()
  ) {
    return <SplashScreen />;
  }

  if (isRaygunEnabled()) {
    rg4js('setUser', {
      identifier: user.email, // A unique ID, email address, or another ID such as a UUID
      isAnonymous: false, // Indicates whether the user is anonymous or not
      uuid: user.id, // Optional device identifier
    });
  }

  return <>{children}</>;
};

export default HasToBeLoggedInGuard;
